import { useWebSocket, whenever, type UseWebSocketOptions } from '@vueuse/core'
import { ref, type MaybeRef } from 'vue'
import type { ServerSocketMessagePayload } from '~shared/types/socket'
import type { ClientSocketMessagePayload } from '~shared/validation/socket'

export const useTurnipExchangeIslandWebSocket = (
  url: MaybeRef<string | undefined>,
  options?: UseWebSocketOptions,
) => {
  const _options = {
    autoConnect: false,
    immediate: false,
    heartbeat: true,
    ...options,
  }

  const { send: _send, data: _data, ...ws } = useWebSocket(url, _options)

  const send = (payload: ClientSocketMessagePayload) => _send(JSON.stringify(payload))

  const data = ref<ServerSocketMessagePayload | undefined>(
    _data.value && _data.value !== 'pong' ? JSON.parse(_data.value) : undefined,
  )

  whenever(
    () => (_data.value && _data.value !== 'pong' ? _data.value : undefined),
    (value) => (data.value = JSON.parse(value)),
  )

  return {
    send,
    data,
    ...ws,
  }
}
